import React, { useState } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import 'react-toastify/dist/ReactToastify.css';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import { convertJsonToXml } from '../Conversion/JsonXmlConvertor';
import RandomContent from '../Components/RandomContent';

const JsonToXml = () => {
    const [inputData, setInputData] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(14);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

    const handleConversion = () => {
        const { convertedData, isError } = convertJsonToXml(inputData);
        setOutputData(convertedData);
        setIsError(isError);
    };

    return (
        <><div>
            <Header />

            <RandomContent />

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-12 col-md-12">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="details">
                                    <h4><a href="#">Convert JSON to XML.</a></h4>
                                    <p>Looking for a Free JSON to XML Conversion Online Tool? Data Beautifier makes it simple and efficient! Our Best JSON to XML Converter Online Tool is designed to transform JSON data into XML format seamlessly. With our Simple JSON to XML Converter Tool, you can handle conversions in just a few clicks—no technical expertise required. Whether you’re a developer or a data enthusiast, our Easy JSON to XML Converter Tool ensures accuracy and speed, saving you valuable time. Accessible anytime, Data Beautifier provides reliable results for free. Simplify your data conversion needs with us today!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="thumb">
                                    <Inputs
                                        value={inputData}
                                        setValue={(val) => {
                                            setInputData(val);
                                            setIsError(false); // Reset error on change
                                        }}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        isError={isError}
                                        lineCol={inputLnCol}
                                        setLineCol={setInputLnCol}
                                        readOnly={false}
                                        idPrefix="input" />
                                </div>
                            </div>
                        </div>

                        {/* Controls */}
                        <div
                            className="w3-col m2"
                            style={{
                                flex: 2,
                                display: 'flex',
                                justifyContent: 'center', // horizontal center
                                alignItems: 'center', // vertical center
                            }}
                        >
                            <button
                                className="default-btn icon four" onClick={handleConversion}>
                                <i className="ri-exchange-line"></i>
                                Convert
                            </button>
                        </div>

                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="1200">
                                <div className="thumb">
                                    <Output
                                        value={outputData}
                                        lineCol={outputLnCol}
                                        setLineCol={setOutputLnCol}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        idPrefix="output" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

            <Footer />
        </>
    );
};

export default JsonToXml;
